import { CSSProperties } from 'react'

import theme from '@/shared/styles/themes/default.theme'
import { SxProps } from '@mui/material'

const styles = {
  modalBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    width: '100%',
    marginTop: theme.spacing(5),
    [theme.breakpoints.down('md')]: {
      marginTop: 0
    }
  } as SxProps,

  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%'
  } as SxProps,

  stepperContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: theme.spacing(2)
  } as SxProps,

  uploadContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  } as SxProps,

  dropZone: (isInteractive: boolean = true) =>
    ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: theme.spacing(2),
      padding: theme.spacing(6),
      borderRadius: theme.shape.borderRadius / 2,
      border: isInteractive ? `1px dashed ${theme.palette.grey[300]}` : `1px solid ${theme.palette.grey[300]}`,
      backgroundColor: theme.palette.grey[50],
      cursor: isInteractive ? 'pointer' : 'default',
      height: 200,
      textAlign: 'center',
      overflow: 'hidden'
    }) as SxProps,

  uploadedFileIcon: {
    fontSize: 48,
    color: theme.palette.error.main
  } as SxProps,

  uploadedFileName: {
    fontWeight: theme.typography.fontWeightMedium,
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  } as SxProps,

  processingContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginTop: theme.spacing(2)
  } as SxProps,

  processingText: {
    color: theme.palette.text.secondary,
    textAlign: 'center'
  } as SxProps,

  reviewContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2
  } as SxProps,

  section: {
    borderRadius: theme.shape.borderRadius / 4,
    border: `1px solid ${theme.palette.grey[200]}`,
    padding: theme.spacing(2)
  } as SxProps,

  twoColGrid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: theme.spacing(2),
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr'
    }
  } as SxProps,

  actionsRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginTop: theme.spacing(2)
  } as SxProps,

  confidenceBadge: {
    fontWeight: theme.typography.fontWeightMedium
  } as SxProps,

  helperText: {
    color: theme.palette.text.secondary
  } as SxProps,

  image: {
    width: 80,
    height: 80
  } as CSSProperties
}

export default styles
